import { render, staticRenderFns } from "./BitacoraNovedadesImagen.vue?vue&type=template&id=58d47a4f"
import script from "./BitacoraNovedadesImagen.vue?vue&type=script&lang=js"
export * from "./BitacoraNovedadesImagen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports